import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { FormattedHTMLMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FormSelectionCard from 'components/FormSelectionCard';
import FormChoiceModal from '../../components/Modals/FormChoiceModal';

const FormSelection = ({ formTypes, selectedFormtype, isFormChoiceShown, customerName, usePreQualifyingQuestionnaire }) => <section className="form-selection">
  <div className="row">
    <div className="col">
      <div className="tooltip mobile-username">
        <div className="row m-0">
          <span className="text-left"><FontAwesomeIcon icon="user-circle" size="lg" /></span>
          <h3 className="col-10 text-left" data-tooltip={ customerName } data-tooltip-conf="bottom">{ customerName }</h3>
          <span className="tooltiptext">{ customerName }</span>
        </div>
      </div>
      <h1 className="underlined">FATCA &amp; CRS Certification</h1>
    </div>
  </div>
  <div className="row">
    <div className="col">
      <h3><FormattedHTMLMessage id="formSelection.welcome" /></h3>
      { usePreQualifyingQuestionnaire && <div className="link">
        <h3><FormattedHTMLMessage id="formSelection.preQuestionnaireText" /><Link to="/" className="btn btn-link"> <FormattedHTMLMessage id="formSelection.preQuestionnaireLink" /></Link></h3>
      </div> }
    </div>
  </div>
  <div className="row">
    <div className="col">
      <div className="form-group">
        <div className="row cards">
          { formTypes && formTypes.map(item => item.isVisible && <div key={ item.formType } className="col-md-6 col-lg-4">
            <FormSelectionCard { ...item } />
          </div>)}
          { isFormChoiceShown
            && <FormChoiceModal
              formType={ selectedFormtype }
            /> }
        </div>
      </div>
    </div>
  </div>
</section>;

FormSelection.propTypes = {
  formTypes: PropTypes.arrayOf(PropTypes.shape({})),
  selectedFormtype: PropTypes.string,
  isFormChoiceShown: PropTypes.bool,
  customerName: PropTypes.string.isRequired,
  usePreQualifyingQuestionnaire: PropTypes.bool,
};

FormSelection.defaultProps = {
  formTypes: [],
  selectedFormtype: '',
  isFormChoiceShown: false,
  usePreQualifyingQuestionnaire: false
};

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig
    },
    form: {
      formType,
      isFormChoiceShown
    }
  } = state;

  return {
    formTypes: onlineConfig && onlineConfig.formTypes,
    selectedFormtype: formType,
    isFormChoiceShown,
    customerName: onlineConfig && onlineConfig.customerName,
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
  };
}

export default connect(
  mapStateToProps,
)(FormSelection);
